import { baseApi } from "../baseApi";

export const GotraApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // CREATE
    createGotra: builder.mutation({
      query: (data) => ({
        url: "/gotra-create",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
      invalidatesTags: ["Gotra"], // ✅ This will auto-refetch
    }),

    // GET ALL
    getGotra: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = "",
        status = "",
      } = {}) =>
        `/gotra-list?page=${page}&limit=${limit}&search=${search}&status=${status}`,
      providesTags: ["Gotra"], // ✅ This provides the tag
    }),

    // UPDATE
    updateGotra: builder.mutation({
      query: (data) => ({
        url: "/gotra-update",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Gotra"], // ✅ This will auto-refetch
    }),

    // STATUS CHANGE
    changeStatusGotra: builder.mutation({
      query: (id) => ({
        url: `/gotra-status/${id}`,
        method: "GET",
      }),
      invalidatesTags: ["Gotra"], // ✅ This will auto-refetch
    }),

    // DELETE
    deleteGotra: builder.mutation({
      query: (id) => ({
        url: `/gotra-delete/${typeof id === 'object' ? id.id : id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Gotra"], // ✅ This will auto-refetch
    }),
  }),
});

export const {
  useCreateGotraMutation,
  useGetGotraQuery,
  useUpdateGotraMutation,
  useDeleteGotraMutation,
  useChangeStatusGotraMutation,
} = GotraApi;